(function() {
  let total_selects;
  total_selects = document.getElementsByClassName('custom-select');

  Array.from(total_selects).forEach(curr_select => {
    let select_element = curr_select.getElementsByTagName('select')[0];
    const input = create_input_div(select_element);
    curr_select.appendChild(input);
    const dropdown = create_options_dropdown();
    create_options_container(dropdown, select_element);
    curr_select.appendChild(dropdown);
    input.addEventListener('click', function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  });

  function create_options_dropdown() {
    let options_dropdown;
    options_dropdown = document.createElement('DIV');
    options_dropdown.setAttribute('class', 'select-items select-hide');
    return options_dropdown;
  }

  function create_input_div(select_element) {
    let input_div;
    input_div = document.createElement('DIV');
    input_div.setAttribute('class', 'select-selected');
    input_div.innerHTML =
      select_element.options[select_element.selectedIndex].innerHTML;
    return input_div;
  }

  function create_options_container(dropdown, select_element) {
    let option_div;
    for (let index = 1; index < select_element.length; index++) {
      option_div = document.createElement('DIV');
      option_div.innerHTML = select_element.options[index].innerHTML;
      option_div.addEventListener('click', function(e) {
        let selected_option, default_selects, previous_sibling;
        default_selects = this.parentNode.parentNode.getElementsByTagName(
          'select'
        )[0];
        previous_sibling = this.parentNode.previousSibling;
        for (let i = 0; i < default_selects.length; i++) {
          if (default_selects.options[i].innerHTML === this.innerHTML) {
            default_selects.selectedIndex = i;
            previous_sibling.innerHTML = this.innerHTML;
            selected_option = this.parentNode.getElementsByClassName(
              'same-as-selected'
            );
            Array.from(selected_option).forEach(opt => {
              opt.removeAttribute('class');
            });
            this.setAttribute('class', 'same-as-selected');
            break;
          }
        }
        previous_sibling.click();
      });
      dropdown.appendChild(option_div);
    }
  }

  function closeAllSelect(elmnt) {
    let options,
      selected_option,
      arrNo = [];
    options = document.getElementsByClassName('select-items');
    selected_option = document.getElementsByClassName('select-selected');
    Array.from(selected_option).forEach((opt, index) => {
      if (elmnt === opt) {
        arrNo.push(index);
      } else {
        opt.classList.remove('select-arrow-active');
      }
    });
    Array.from(options).forEach((opt, index) => {
      if (arrNo.indexOf(index)) {
        opt.classList.add('select-hide');
      }
    });
  }

  document.addEventListener('click', closeAllSelect);
})();
